import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { dashboard_lang } from "../../language/dashboard";
import * as Chart from 'chart.js';
declare var dashboard_enable;
dashboard_enable = false;
import * as moment from 'moment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";

  language: any;
  counter = 0;
  months = [
    // {value:0,name_th:'all',n},
    { value: 1, name: { TH: 'มกราคม', EN: "January" } },
    { value: 2, name: { TH: 'กุมภาพันธ์', EN: "February" } },
    { value: 3, name: { TH: 'มีนาคม', EN: "March" } },
    { value: 4, name: { TH: 'เมษายน', EN: "April" } },
    { value: 5, name: { TH: "พฤษภาคม", EN: "May" } },
    { value: 6, name: { TH: "มิถุนายน", EN: "June" } },
    { value: 7, name: { TH: "กรกฏาคม", EN: "July" } },
    { value: 8, name: { TH: "สิงหาคม", EN: "August" } },
    { value: 9, name: { TH: "กันยายน", EN: "September" } },
    { value: 10, name: { TH: "ตุลาคม", EN: "October" } },
    { value: 11, name: { TH: "พฤศจิกายน", EN: "November" } },
    { value: 12, name: { TH: "ธันวาคม", EN: "December" } }
  ];
  types = [
    { value: 2, name: { TH: 'รายวัน', EN: "Report of Daily" } },
    { value: 1, name: { TH: 'รายเดือน', EN: "Report of Month" } },
    { value: 3, name: { TH: 'รายปี', EN: "Report of Year" } },
    { value: 4, name: { TH: 'ระบุวันเริ่มต้น/สิ้นสุด', EN: "Specify start/end date" } },
    // { value: 4, name: { TH: '3 เดือนย้อน', EN: "3 months back" } },
    // { value: 5, name: { TH: '6 เดือนย้อน', EN: "6 months back" } },
  ]
  type = 1;
  // month=0;
  areaChartofYear = {
    chartType: 'AreaChart',
    dataTable: [],
    options: {
      isStacked: true,
      height: 300,
      legend: { position: 'top', maxLines: 2 },
      vAxis: { minValue: 0 },
      colors: ['#FB9678', '#FB9678']
    },
  };
  month = new Date().getMonth() + 1;
  year = new Date().getFullYear();
  years: any;
  count = 0;
  dataOfchartY;
  interval: any;
  show: boolean = true;
  daysInmonth = null;
  days = null;
  day = new Date().getDay() + 1;
  date = {
    start_date: moment(`${moment().add(-1,'year').get('year')}-10-01`).format("YYYY-MM-DD"),
    end_date:moment(`${moment().get('year')}-09-30`).format("YYYY-MM-DD")
  }
  total_income = null;
  total_revenue = null;
  total_price = this.total_income + this.total_revenue;
  constructor(private service: MyserviceService, private chRef: ChangeDetectorRef, private route: ActivatedRoute, private router: Router) {
    this.language = dashboard_lang[this.lang];
  }
  cards = {
    TH: [
      {
        name: "ใบแจ้งหนี้(ประจำวัน)",
        number: 0,
        text: "เป็นเงิน",
        quantity: 0,
        icon: "fas fa-scroll",
        url: "/report_invoice/month",
        unit: "บาท"
      }, {
        name: "ใบทวงหนี้(ประจำวัน)",
        number: 0,
        text: "เป็นเงิน",
        url: "/report_inform/month",
        icon: "fas fa-paste",
        quantity: 0,
        unit: "บาท"
      }, {
        name: "ใบเสร็จรับเงิน(ประจำวัน)",
        number: 0,
        text: "เป็นเงิน",
        quantity: 0,
        url: "/report_bill/month",
        icon: "fas fa-money-check-alt",
        unit: "บาท"
      }, {
        name: "การปรับปรุง(ประจำวัน)",
        number: 0,
        text: "จำนวน",
        quantity: 0,
        url: "/customer_request/month",
        icon: "fas fa-building",
        unit: "ตำแหน่ง"
      },
      // {
      //   name: "ใบแจ้งหนี้(ประจำเดือน)",
      //   number: 0,
      //   text: "เป็นเงิน",
      //   quantity: 0,
      //   icon: "fas fa-scroll",
      //   url: "/report_invoice/month",
      //   unit: "บาท"
      // }, {
      //   name: "ใบทวงหนี้(ประจำเดือน)",
      //   number: 0,
      //   text: "เป็นเงิน",
      //   url: "/report_inform/month",
      //   icon: "fas fa-paste",
      //   quantity: 0,
      //   unit: "บาท"
      // }, {
      //   name: "ใบเสร็จรับเงิน(ประจำเดือน)",
      //   number: 0,
      //   text: "เป็นเงิน",
      //   quantity: 0,
      //   url: "/report_bill/month",
      //   icon: "fas fa-money-check-alt",
      //   unit: "บาท"
      // }, {
      //   name: "การปรับปรุง(ประจำเดือน)",
      //   number: 0,
      //   text: "จำนวน",
      //   quantity: 0,
      //   url: "/customer_request/month",
      //   icon: "fas fa-building",
      //   unit: "ตำแหน่ง"
      // },
      // {
      //   name: "ใบแจ้งหนี้(ประจำปี)",
      //   number: 0,
      //   text: "เป็นเงิน",
      //   quantity: 0,
      //   icon: "fas fa-scroll",
      //   url: "/report_invoice/year",
      //   unit: "บาท"
      // }, {
      //   name: "ใบทวงหนี้(ประจำปี)",
      //   number: 0,
      //   text: "เป็นเงิน",
      //   url: "/report_inform/year",
      //   icon: "fas fa-paste",
      //   quantity: 0,
      //   unit: "บาท"
      // }, {
      //   name: "ใบเสร็จรับเงิน(ประจำปี)",
      //   number: 0,
      //   text: "เป็นเงิน",
      //   quantity: 0,
      //   url: "/report_bill/year",
      //   icon: "fas fa-money-check-alt",
      //   unit: "บาท"
      // }, {
      //   name: "การปรับปรุง(ประจำปี)",
      //   number: 0,
      //   text: "จำนวน",
      //   quantity: 0,
      //   url: "/customer_request/year",
      //   icon: "fas fa-building",
      //   unit: "ตำแหน่ง"
      // }
    ],
    EN: [
      {
        name: "Invoice(Monthly)",
        number: 0,
        text: "is",
        quantity: 0,
        icon: "fas fa-scroll",
        url: "/report_invoice/month",
        unit: "Bath"
      }, {
        name: "Collect debt(Monthly)",
        number: 0,
        text: "is",
        url: "/report_inform/month",
        icon: "fas fa-paste",
        quantity: 0,
        unit: "Bath"
      }, {
        name: "Payment(Monthly)",
        number: 0,
        text: "is",
        quantity: 0,
        url: "/report_bill/month",
        icon: "fas fa-money-check-alt",
        unit: "Bath"
      }, {
        name: "Modify Data(Monthly)",
        number: 0,
        text: "Count",
        quantity: 0,
        url: "/customer_request/month",
        icon: "fas fa-building",
        unit: "location"
      },
      // {
      //   name: "Invoice(Yearly)",
      //   number: 0,
      //   text: "is",
      //   quantity: 0,
      //   icon: "fas fa-scroll",
      //   url: "/report_invoice/year",
      //   unit: "Bath"
      // }, {
      //   name: "Collect debt(Yearly)",
      //   number: 0,
      //   text: "is",
      //   url: "/report_inform/year",
      //   icon: "fas fa-paste",
      //   quantity: 0,
      //   unit: "Bath"
      // }, {
      //   name: "Payment(Yearly)",
      //   number: 0,
      //   text: "is",
      //   quantity: 0,
      //   url: "/report_bill/year",
      //   icon: "fas fa-money-check-alt",
      //   unit: "Bath"
      // }, {
      //   name: "Modify Data(Yearly)",
      //   number: 0,
      //   text: "Count",
      //   quantity: 0,
      //   url: "/customer_request/year",
      //   icon: "fas fa-building",
      //   unit: "Location"
      // }
    ]
  }
  monthLabel = {
    TH: ['มกราคม', 'กุมพาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤษจิกายน', 'ธันวาคม'],
    EN: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  }

  isLoading = false;

  // ngAfterViewInit() {
  //   const canvas = <HTMLCanvasElement>document.getElementById('pieChart');
  //   const canvas_line = <HTMLCanvasElement>document.getElementById('lineChart');
  //   const ctx = canvas.getContext('2d');
  //   const ctx_line = canvas_line.getContext('2d');
  //   // if (this.lineChartCanvas && this.pieChartCanvas) {
  //   // use pieChartCtx to draw on the pie chart canvas
  //   new Chart(ctx_line, {
  //     type: 'line',
  //     data: {
  //       labels: this.monthLabel[this.lang],
  //       datasets: [{
  //         label: 'My First dataset',
  //         backgroundColor: 'rgba(255, 99, 132, 0.2)',
  //         borderColor: 'rgba(255, 99, 132, 1)',
  //         data: [65, 59, 80, 81, 56, 55, 40]
  //       }]

  //     },
  //     options: {
  //       layout: {
  //         padding: {
  //           left: 0,
  //           right: 0,
  //           top: 0,
  //           bottom: 0
  //         }
  //       },
  //       title: {
  //         display: true,
  //         text: `${this.lang == 'EN' ? 'Number of Fee Payers' : 'จำนวนผู้เสียค่าธรรมเนียม'}`,
  //         fontSize: 18,
  //         fontColor: '#000'
  //       },
  //       plugins: {
  //         labels: [
  //           {
  //             render: 'value',
  //             fontColor: '#fff',
  //             position: 'center'
  //           }
  //         ]
  //       }
  //     }
  //   });
  //   new Chart(ctx, {
  //     type: 'doughnut',
  //     data: {
  //       labels: [`${this.lang == 'EN' ? 'outstanding balance' : 'ยอดคงค้าง'}`, `${this.lang == 'EN' ? 'amount received' : 'ยอดเงินรับ'}`],
  //       datasets: [{
  //         label: '# of Votes',
  //         data: [50, 500],
  //         backgroundColor: [
  //           '#1AD598',
  //           '#0088B8',
  //         ],
  //         borderColor: [
  //           '#1AD598',
  //           '#0088B8',
  //         ],
  //       }]
  //     },
  //     options: {
  //       layout: {
  //         padding: {
  //           left: 0,
  //           right: 0,
  //           top: 0,
  //           bottom: 0
  //         }
  //       },
  //       title: {
  //         display: true,
  //         text: `${this.lang == 'EN' ? 'Revenue' : 'รายรับ'}`,
  //         fontSize: 18,
  //         fontColor: '#000'
  //       },
  //       plugins: {
  //         labels: [
  //           {
  //             render: 'value',
  //             fontColor: '#fff',
  //             position: 'center'
  //           }
  //         ]
  //       }
  //     }

  //   })
  //   // }
  //   // use lineChartCtx to draw on the line chart canvas

  // }
  ngOnDestroy() {
    dashboard_enable = false;
    var interval_id = window.setInterval("", 9999); // Get a reference to the last
    // interval +1
    for (var i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }

  ngOnInit() {

    // this.dataOfchartY = [
    //   ['2016', 0],
    //   ['2017', 0],
    //   ['2018', 0],
    //   ['2019', 0],
    //   ['2020', 0]
    // ]
    // this.areaChartofYear = {
    //   chartType: 'AreaChart',
    //   dataTable: this.dataOfchartY,
    //   options: {
    //     isStacked: true,
    //     height: 300,
    //     legend: { position: 'top', maxLines: 2 },
    //     vAxis: { minValue: 0 },
    //     colors: ['#FB9678', '#FB9678']
    //   },
    // };


    console.log(this.month);
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }
    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
    if (parseInt(this.year.toString()) < 2500) {
      this.year = this.year + 543;
    }

    var interval_id = window.setInterval("", 9999); // Get a reference to the last
    // interval +1
    for (var i = 1; i < interval_id; i++)
      window.clearInterval(i);
    this.years = [];
    for (var i = 0; i < 5; i++) {
      this.years.push(this.year - i);
    }

    dashboard_enable = true;
    this.get_data();
    setInterval(() => {
      this.get_data();
    }, 30000);
    this.route.queryParams.subscribe(params => {
      this.lang = params['lang'];
      if (this.lang != 'EN' && this.lang != 'TH') {
        this.lang = localStorage.getItem('lang') == 'EN' ? 'EN' : 'TH';
        this.language = dashboard_lang[this.lang];
      } else {
        this.language = dashboard_lang[this.lang];
        localStorage.setItem('lang', this.lang);
      }
    });
  }


  monthChange() {
    let year_db = 0;
    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }

    this.daysInmonth = new Date(parseInt(year_db.toString(), 10), parseInt(this.month.toString(), 10), 0).getDate();
    this.daysInmonth = parseInt(this.daysInmonth.toString(), 10);
    this.days = [];
    for (var i = 0; i <= this.daysInmonth - 1; i++) {
      this.days.push(i + 1);
    }
  }
  get_data() {
    if (this.type == 4) {
      if ((!this.date.start_date || !this.date.end_date )|| moment(this.date.start_date).format("YYYY-MM-DD") > moment(this.date.end_date).format("YYYY-MM-DD")) {
        return Swal.fire({
          text: 'ใส่ข้อมูลไม่ถูกต้อง',
          type: 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
        })
      }
      if ((!this.date.start_date || !this.date.end_date )|| moment(this.date.end_date).format("YYYY-MM-DD") < moment(this.date.start_date).format("YYYY-MM-DD")) {
        return Swal.fire({
          text: 'ใส่ข้อมูลไม่ถูกต้อง',
          type: 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
        })
      }

    }

    // this.isLoading=true;
    if (dashboard_enable == true) {
      let year_db = 0;

      if (this.year > 2500) {
        year_db = this.year - 543;
      } else {
        year_db = this.year
      }

      this.counter = 30;
      this.count = 1;
      if (this.count != 0) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(() => {
        this.counter--;
      }, 1000);
      this.isLoading = true;
      // debugger
      // if (this.type == 1)
      // {
      localStorage.setItem('month', JSON.stringify(this.month));
      localStorage.setItem('day', JSON.stringify(!this.day ? 0 : this.day));
      localStorage.setItem('year', JSON.stringify(year_db));
      localStorage.setItem('type_filter', JSON.stringify(this.type));

      this.service.postData({ month: this.month, year: year_db, day: !this.day ? 0 : this.day, type: this.type, date_filter: this.date }, "invoice/dashboard").then((result: any) => {
        const result_ = result.data[0];
        console.log(result_);
        var formatter = new Intl.NumberFormat('th-TH', {
          style: 'currency',
          currency: 'THB',
        });
        console.log(formatter.format(20313));
        this.total_income = formatter.format(result_.total_backlog_quantity)
        this.total_revenue = formatter.format(result_.bill_quantity)
        this.total_price = formatter.format(result_.total_backlog_quantity + result_.bill_quantity)
        this.cards.EN[0].number = result_.invoice_number == "null" ? "0" : result_.invoice_number;
        this.cards.EN[0].quantity = result_.invoice_quantity == "null" ? "0" : result_.invoice_quantity;
        this.cards.EN[0].name = `${this.type == 1 ? "Invoice" : this.type == 2 ? "Invoice" : 'Invoice'}`;
        this.cards.TH[0].number = result_.invoice_number == "null" ? "0" : result_.invoice_number;
        this.cards.TH[0].quantity = result_.invoice_quantity == "null" ? "0" : result_.invoice_quantity;
        this.cards.TH[0].name = `${this.type == 1 ? "ใบแจ้งหนี้" : this.type == 2 ? "ใบแจ้งหนี้" : 'ใบแจ้งหนี้'}`;


        this.cards.EN[1].number = result_.inform_number == "null" ? "0" : result_.inform_number;
        this.cards.EN[1].quantity = result_.inform_quantity == "null" ? "0" : result_.inform_quantity;
        this.cards.EN[1].name = `${this.type == 1 ? "invoice debt" : this.type == 2 ? "invoice debt" : 'invoice debt'}`;
        this.cards.TH[1].number = result_.inform_number == "null" ? "0" : result_.inform_number;
        this.cards.TH[1].quantity = result_.inform_quantity == "null" ? "0" : result_.inform_quantity;
        this.cards.TH[1].name = `${this.type == 1 ? "ใบทวงหนี้" : this.type == 2 ? "ใบทวงหนี้" : 'ใบทวงหนี้'}`;

        this.cards.EN[2].number = result_.bill_number == "null" ? "0" : result_.bill_number;
        this.cards.EN[2].quantity = result_.bill_quantity == "null" ? "0" : result_.bill_quantity;
        this.cards.EN[2].name = `${this.type == 1 ? "Bil" : this.type == 2 ? "Bil" : 'Bil'}`;
        this.cards.TH[2].number = result_.bill_number == "null" ? "0" : result_.bill_number;
        this.cards.TH[2].quantity = result_.bill_quantity == "null" ? "0" : result_.bill_quantity;
        this.cards.TH[2].name = `${this.type == 1 ? "ใบเสร็จรับเงิน" : this.type == 2 ? "ใบเสร็จรับเงิน" : 'ใบเสร็จรับเงิน'}`;

        this.cards.EN[3].number = result_.total_log == "null" ? "0" : result_.total_log;
        this.cards.EN[3].quantity = result_.total_log_quantity == "null" ? "0" : result_.total_log_quantity;
        this.cards.EN[3].name = `${this.type == 1 ? "Change Data" : this.type == 2 ? "Change Data" : 'Change Data'}`;
        this.cards.TH[3].number = result_.total_log == "null" ? "0" : result_.total_log;
        this.cards.TH[3].quantity = result_.total_log_quantity == "null" ? "0" : result_.total_log_quantity;
        this.cards.TH[3].name = `${this.type == 1 ? "การปรับปรุง" : this.type == 2 ? "การปรับปรุง" : 'การปรับปรุง'}`;
        // this.cards.EN[1].number=result_.invoice_dept_number_month=="null"?"0":result_.invoice_dept_number_month;
        // this.cards.EN[1].quantity=result_.invoice_dept_quantity_month=="null"?"0":result_.invoice_dept_quantity_month;
        // this.cards.TH[1].number=result_.invoice_dept_number_month=="null"?"0":result_.invoice_dept_number_month;
        // this.cards.TH[1].quantity=result_.invoice_dept_quantity_month=="null"?"0":result_.invoice_dept_quantity_month;

        // this.cards.EN[2].number=result_.bill_number_month=="null"?"0":result_.bill_number_month;
        // this.cards.EN[2].quantity=result_.bill_quantity_month=="null"?"0":result_.bill_quantity_month;
        // this.cards.TH[2].number=result_.bill_number_month=="null"?"0":result_.bill_number_month;
        // this.cards.TH[2].quantity=result_.bill_quantity_month=="null"?"0":result_.bill_quantity_month;

        // this.cards.EN[3].number=result_.log_month=="null"?"0":result_.log_month;
        // this.cards.EN[3].quantity=result_.log_size_month=="null"?"0":result_.log_size_month;
        // this.cards.TH[3].number=result_.log_month=="null"?"0":result_.log_month;
        // this.cards.TH[3].quantity=result_.log_size_month=="null"?"0":result_.log_size_month;
        // this.cards.EN[4].number = result_.invoice_number_year == "null" ? "0" : result_.invoice_number_year;
        // this.cards.EN[4].quantity = result_.invoice_quantity_year == "null" ? "0" : result_.invoice_quantity_year;
        // this.cards.TH[4].number = result_.invoice_number_year == "null" ? "0" : result_.invoice_number_year;
        // this.cards.TH[4].quantity = result_.invoice_quantity_year == "null" ? "0" : result_.invoice_quantity_year;

        // this.cards.EN[5].number = result_.invoice_dept_number_year == "null" ? "0" : result_.invoice_dept_number_year;
        // this.cards.EN[5].quantity = result_.invoice_dept_quantity_year == "null" ? "0" : result_.invoice_dept_quantity_year;
        // this.cards.TH[5].number = result_.invoice_dept_number_year == "null" ? "0" : result_.invoice_dept_number_year;
        // this.cards.TH[5].quantity = result_.invoice_dept_quantity_year == "null" ? "0" : result_.invoice_dept_quantity_year;

        // this.cards.EN[6].number = result_.bill_number_year == "null" ? "0" : result_.bill_number_year;
        // this.cards.EN[6].quantity = result_.bill_quantity_year == "null" ? "0" : result_.bill_quantity_year;
        // this.cards.TH[6].number = result_.bill_number_year == "null" ? "0" : result_.bill_number_year;
        // this.cards.TH[6].quantity = result_.bill_quantity_year == "null" ? "0" : result_.bill_quantity_year;

        // this.cards.EN[7].number = result_.log_year == "null" ? "0" : result_.log_year;
        // this.cards.EN[7].quantity = result_.log_size_year == "null" ? "0" : result_.log_size_year;
        // this.cards.TH[7].number = result_.log_year == "null" ? "0" : result_.log_year;
        // this.cards.TH[7].quantity = result_.log_size_year == "null" ? "0" : result_.log_size_year;
        console.log(this.cards);
        this.isLoading = false;
      })
      // }
      // else
      // {
      //   localStorage.setItem('month',undefined);
      //   localStorage.setItem('year',undefined);
      //     this.service.postData({month:undefined,year:undefined},"invoice/dashboard").then((result:any)=>{
      //     result=result.data[0];
      //     this.cards.EN[0].number=result.invoice_number_month=="null"?"0":result.invoice_number_month;
      //     this.cards.EN[0].quantity=result.invoice_quantity_month=="null"?"0":result.invoice_quantity_month;
      //     this.cards.TH[0].number=result.invoice_number_month=="null"?"0":result.invoice_number_month;
      //     this.cards.TH[0].quantity=result.invoice_quantity_month=="null"?"0":result.invoice_quantity_month;
      //     this.cards.TH[0].name = "ยอดคงค้าง(ประจำวัน)";
      //     this.cards.EN[0].name = "Invoice(Daliy)";

      //     this.cards.EN[1].number=result.invoice_dept_number_month=="null"?"0":result.invoice_dept_number_month;
      //     this.cards.EN[1].quantity=result.invoice_dept_quantity_month=="null"?"0":result.invoice_dept_quantity_month;
      //     this.cards.TH[1].number=result.invoice_dept_number_month=="null"?"0":result.invoice_dept_number_month;
      //     this.cards.TH[1].quantity=result.invoice_dept_quantity_month=="null"?"0":result.invoice_dept_quantity_month;
      //     this.cards.TH[1].name = "ใบทวงหนี้(ประจำวัน)";
      //     this.cards.EN[1].name = "invoice debt(Daliy)";

      //     this.cards.EN[2].number=result.bill_number_month=="null"?"0":result.bill_number_month;
      //     this.cards.EN[2].quantity=result.bill_quantity_month=="null"?"0":result.bill_quantity_month;
      //     this.cards.TH[2].number=result.bill_number_month=="null"?"0":result.bill_number_month;
      //     this.cards.TH[2].quantity=result.bill_quantity_month=="null"?"0":result.bill_quantity_month;
      //     this.cards.TH[2].name = "ชำระเงิน(ประจำวัน)";
      //     this.cards.EN[2].name = "Bill(Daliy)";

      //     this.cards.EN[3].number=result.log_month=="null"?"0":result.log_month;
      //     this.cards.EN[3].quantity=result.log_size_month=="null"?"0":result.log_size_month;
      //     this.cards.TH[3].number=result.log_month=="null"?"0":result.log_month;
      //     this.cards.TH[3].quantity=result.log_size_month=="null"?"0":result.log_size_month;
      //     this.cards.TH[3].name = "การปรับปรุง(ประจำวัน)";
      //     this.cards.EN[3].name = "Change Data(Daliy)";

      //     //console.log(this.cards.EN[3]);
      //     this.cards.EN[4].number=result.invoice_number_year=="null"?"0":result.invoice_number_year;
      //     this.cards.EN[4].quantity=result.invoice_quantity_year=="null"?"0":result.invoice_quantity_year;
      //     this.cards.TH[4].number=result.invoice_number_year=="null"?"0":result.invoice_number_year;
      //     this.cards.TH[4].quantity=result.invoice_quantity_year=="null"?"0":result.invoice_quantity_year;

      //     this.cards.EN[5].number=result.invoice_dept_number_year=="null"?"0":result.invoice_dept_number_year;
      //     this.cards.EN[5].quantity=result.invoice_dept_quantity_year=="null"?"0":result.invoice_dept_quantity_year;
      //     this.cards.TH[5].number=result.invoice_dept_number_year=="null"?"0":result.invoice_dept_number_year;
      //     this.cards.TH[5].quantity=result.invoice_dept_quantity_year=="null"?"0":result.invoice_dept_quantity_year;

      //     this.cards.EN[6].number=result.bill_number_year=="null"?"0":result.bill_number_year;
      //     this.cards.EN[6].quantity=result.bill_quantity_year=="null"?"0":result.bill_quantity_year;
      //     this.cards.TH[6].number=result.bill_number_year=="null"?"0":result.bill_number_year;
      //     this.cards.TH[6].quantity=result.bill_quantity_year=="null"?"0":result.bill_quantity_year;

      //     this.cards.EN[7].number=result.log_year=="null"?"0":result.log_year;
      //     this.cards.EN[7].quantity=result.log_size_year=="null"?"0":result.log_size_year;
      //     this.cards.TH[7].number=result.log_year=="null"?"0":result.log_month;
      //     this.cards.TH[7].quantity=result.log_size_year=="null"?"0":result.log_size_year;
      //     this.isLoading =false;
      //   })
      // }
    }

  }

  typeChange() {
    if (this.type == 1) {
      this.show = true;
    } else { this.show = false; }
  }

  routerLink(url) {
    let year_db = 0;

    if (this.year > 2500) {
      year_db = this.year - 543;
    } else {
      year_db = this.year
    }
    // debugger
    localStorage.setItem('month', JSON.stringify(this.month));
    localStorage.setItem('year', JSON.stringify(year_db));
    localStorage.setItem('day', JSON.stringify(this.day));
    localStorage.setItem('type', JSON.stringify(this.type));
    if (this.type == 4) {
      localStorage.setItem('datefilter', JSON.stringify(this.date));

    }
    switch (url) {
      case "/report_invoice/month":
        this.router.navigate(['../report_invoice'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/report_invoice/year":
        this.router.navigate(['../report_invoice'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/report_inform/month":
        this.router.navigate(['../report_inform'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/report_inform/year":
        this.router.navigate(['../report_inform'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/report_bill/month":
        this.router.navigate(['../report_bill'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/report_bill/year":
        this.router.navigate(['../report_bill'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/customer_request/month":
        localStorage.setItem('type', JSON.stringify(this.type));
        this.router.navigate(['../customer_request'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
      case "/customer_request/year":
        localStorage.setItem('type', JSON.stringify(this.type));
        this.router.navigate(['../customer_request'],
          {
            relativeTo: this.route,
            queryParams: { lang: this.lang },
            queryParamsHandling: 'merge'
          }
        );
        break;
    }
  }

}
